export type Language = 'en' | 'es'

export const t = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      pricing: 'Pricing',
      gallery: 'Gallery',
      faq: 'FAQ',
      rescueMe: 'GET A QUOTE',
    },
    hero: {
      headline: 'MOVING CRITICAL? CALL THE FIGHTERS.',
      sub: "We don't just move boxes; we execute residential rescues. Fixed-rate or hourly options. Florida's most trusted moving squad.",
      cta: 'GET MY QUOTE',
    },
    trustBar: {
      moves: 'Successful Rescues',
      rating: 'Google Rating',
      pricing: 'Flexible Pricing',
      licensed: 'Licensed & Insured',
    },
    howItWorks: {
      title: 'HOW IT WORKS',
      step1: {
        title: 'Request Your Rescue',
        desc: 'Fill out the form. A specialist calls you back to discuss details and pricing.',
      },
      step2: {
        title: 'We Deploy',
        desc: 'Our uniformed squad arrives on time with all equipment ready.',
      },
      step3: {
        title: 'Mission Complete',
        desc: 'Everything in its place. Transparent invoice. Job done.',
      },
    },
    booking: {
      title: 'REQUEST A RESCUE',
      subtitle:
        'Fill out the form below and a Move Fighters specialist will call you back to discuss the details of your move and your custom quote.',
      sizeLabel: 'Move Size',
      sizeOptions: [
        { value: 'studio', label: 'Studio / 1 Bedroom' },
        { value: '2bedroom', label: '2 Bedrooms' },
        { value: '3bedroom', label: '3 Bedrooms' },
        { value: '4bedroom', label: '4+ Bedrooms / Large Home' },
        { value: 'office', label: 'Office / Commercial' },
      ],
      serviceTypeLabel: 'Pricing Preference',
      serviceTypeOptions: [
        { value: 'flat', label: 'Flat-Rate Quote' },
        { value: 'hourly', label: 'Hourly Rate' },
        { value: 'either', label: 'Show Me Both' },
      ],
      originLabel: 'Pickup Address',
      destLabel: 'Delivery Address',
      dateLabel: 'Preferred Moving Date',
      dateHint: 'We recommend 72h advance notice',
      nameLabel: 'Full Name',
      emailLabel: 'Email Address',
      phoneLabel: 'Phone Number',
      notesLabel: 'Additional Notes (optional)',
      notesPlaceholder: 'Stairs, large items, parking restrictions, etc.',
      submit: 'REQUEST MY QUOTE',
      submitting: 'SENDING...',
      footer: 'No payment required. A specialist will contact you shortly.',
      success: {
        title: 'REQUEST RECEIVED',
        message:
          'Thank you for choosing Move Fighters. One of our specialists will call you shortly from',
        phone: '(813) 476-8935',
        message2:
          "with your custom quote and final pricing. Please answer — the call will come from this exact number so you don't miss your rescue.",
        cta: 'BACK TO HOMEPAGE',
      },
      error:
        'Something went wrong. Please try again or call us at (813) 476-8935.',
    },
    pricing: {
      title: 'OUR MOVING PACKAGES',
      subtitle:
        'Choose the package that fits your move. Final pricing is provided after a quick call with our specialist.',
      popular: 'MOST POPULAR',
      cta: 'GET A QUOTE',
      cards: [
        {
          title: 'Studio / 1 Bedroom',
          features: [
            '2 Fighters',
            'Moving Truck',
            'Travel Fee Included',
            'Disassembly & Reassembly Included',
            'Stairs at No Extra Charge',
            'Residential Insurance',
          ],
        },
        {
          title: '2 Bedroom Home',
          features: [
            '3 Fighters',
            'Moving Truck',
            'Travel Fee Included',
            'Disassembly & Reassembly Included',
            'Stairs at No Extra Charge',
            'Residential Insurance',
          ],
        },
        {
          title: '3 Bedroom Home',
          features: [
            '3 Fighters',
            'Larger Truck',
            'Travel Fee Included',
            'Disassembly & Reassembly Included',
            'Priority Scheduling',
            'Residential Insurance',
          ],
        },
        {
          title: '4+ Bedroom / Custom',
          features: [
            '4+ Fighters',
            'Multiple Trucks',
            'Travel Fee Included',
            'Disassembly & Reassembly Included',
            'Dedicated Coordinator',
            'Specialty & White Glove Handling',
          ],
        },
      ],
      note: '* Packing materials (boxes, tape, paper, wrap) billed separately based on usage.',
    },
    quoteModal: {
      title: 'TELL US ABOUT YOUR MOVE',
      subtitle:
        'The more details you share, the more accurate your quote will be. Our specialist will call you back with the final price.',
      selectedPackage: 'Selected package',
      sectionContact: 'Your contact info',
      sectionAddresses: 'Addresses',
      sectionDate: 'When are you moving?',
      sectionInventory: 'Inventory & details',
      sectionPhotos: 'Photos (optional but recommended)',
      nameLabel: 'Full Name',
      phoneLabel: 'Phone Number',
      emailLabel: 'Email Address',
      originLabel: 'Pickup Address',
      originPlaceholder: '123 Main St, City, FL — include floor / apt #',
      destLabel: 'Delivery Address',
      destPlaceholder: '456 New St, City, FL — include floor / apt #',
      stairsLabel: 'Stairs / Elevator',
      stairsOptions: [
        { value: 'ground', label: 'Ground floor only' },
        { value: 'stairs', label: 'Stairs' },
        { value: 'elevator', label: 'Elevator' },
        { value: 'both', label: 'Both locations have stairs/elevator' },
      ],
      dateLabel: 'Preferred Move Date',
      dateFlexLabel: 'Flexibility',
      dateFlexOptions: [
        { value: 'exact', label: 'Exact date' },
        { value: 'flexible-3', label: 'Flexible (±3 days)' },
        { value: 'flexible-week', label: 'Flexible (within a week)' },
        { value: 'asap', label: 'As soon as possible' },
      ],
      inventoryLabel: 'Describe your inventory',
      inventoryPlaceholder:
        'List rooms and main items (e.g. king bed, sectional sofa, washer/dryer, 55" TV, dining table for 6, large mirrors, gym equipment...)',
      specialItemsLabel: 'Special items (check all that apply)',
      specialItems: [
        'Piano',
        'Pool Table',
        'Safe',
        'Gun Safe',
        'Artwork / Antiques',
        'Aquarium',
        'Treadmill / Gym',
        'Large TV (65"+)',
        'Hot Tub',
        'Appliances',
      ],
      packingLabel: 'Do you need packing service?',
      packingOptions: [
        { value: 'no', label: 'No, I will pack everything myself' },
        { value: 'partial', label: 'Partial — I need help with fragile items' },
        { value: 'full', label: 'Full packing service' },
      ],
      notesLabel: 'Special needs or anything else we should know',
      notesPlaceholder:
        'Long carry, narrow doorways, parking restrictions, time windows, pets, etc.',
      photosLabel: 'Upload photos and videos of your items / rooms',
      photosHint:
        'Images and videos welcome. Up to 15 files, 50 MB total. Helps us quote more accurately.',
      photosButton: 'Choose files',
      photosSelected: 'file(s) selected',
      maxFilesNote: 'files max',
      maxTotalNote: '50 MB total',
      largeFilesNote:
        'Your files are large. We will send your details to our team and ask you to also share the photos/videos via WhatsApp or text to (813) 476-8935 — that way nothing gets lost.',
      submit: 'SEND MY DETAILS',
      submitting: 'SENDING...',
      cancel: 'Cancel',
      success: {
        title: 'GOT IT — DETAILS RECEIVED',
        message: 'Thank you. Our specialist will call you shortly from',
        phone: '(813) 476-8935',
        message2:
          'with your custom quote and final price. Please answer — the call will come from this exact number.',
        nextStepsTitle: 'What happens next',
        nextSteps: [
          'Our specialist reviews your inventory and addresses (within minutes during business hours).',
          'You receive a call from (813) 476-8935 with your custom quote and final price.',
          'Once you confirm, we lock in your moving date and your Fighters squad.',
        ],
        largeFilesTitle: 'One quick favor',
        largeFilesMessage:
          'Your photos/videos were too large to attach. Please send them via WhatsApp or text to (813) 476-8935 so we can finalize your quote faster.',
        cta: 'CLOSE',
      },
      error:
        'Something went wrong. Please try again or call us at (813) 476-8935.',
      photosTooLarge:
        'Total file size exceeds 50 MB. Please remove some or use smaller files.',
    },
    services: {
      title: 'OUR RESCUE PROTOCOLS',
      items: [
        {
          title: 'Residential Rescues',
          desc: 'Houses and apartments handled by uniformed Fighters. Stairs, tight halls, and elevators included at no extra charge.',
        },
        {
          title: 'Commercial Extractions',
          desc: 'Office and retail moves executed fast so your business never slows down.',
        },
        {
          title: 'Packing & Protection',
          desc: 'Optional packing service available. Industrial blankets, plastic wrap, and professional boxes available on request, billed separately.',
        },
        {
          title: 'Last Minute Dispatch',
          desc: 'Coordinated logistics in record time for urgent or fixed-date moves across Florida.',
        },
      ],
    },
    guarantee: {
      title: 'THE MOVE FIGHTERS GUARANTEE',
      sub: 'Transparent pricing. Honest service. Always on time.',
      items: ['No Surprise Fees', 'On-Time Arrival', 'Damage Protection'],
    },
    gallery: {
      title: 'FIGHTERS IN ACTION',
    },
    testimonials: {
      title: 'WHAT OUR RESCUED FAMILIES SAY',
      reviews: [
        {
          quote:
            'These guys are the real deal. Clear pricing, no surprises, and they treated my furniture like it was theirs. Best movers in Tampa!',
          name: 'Maria G.',
          location: 'Tampa, FL',
          timeAgo: '2 months ago',
          color: 'bg-blue-500',
        },
        {
          quote:
            'I was stressed about my last-minute move but Move Fighters showed up on time and had everything done in 3 hours. Incredible.',
          name: 'James R.',
          location: 'Orlando, FL',
          timeAgo: '3 weeks ago',
          color: 'bg-red-500',
        },
        {
          quote:
            'True professionals. Specialist called me back in minutes after I requested a quote. My 3-bedroom move was perfect from start to finish.',
          name: 'Carlos M.',
          location: 'Miami, FL',
          timeAgo: '1 month ago',
          color: 'bg-green-500',
        },
      ],
    },
    coverage: {
      title: "FLORIDA'S LARGEST RESCUE NETWORK",
      subtitle: 'We cover the entire state, from the Panhandle to the Keys.',
      mapHint: 'Tap a city pin to see coverage details',
    },
    faq: {
      title: 'FREQUENTLY ASKED QUESTIONS',
      items: [
        {
          q: 'How does your pricing work?',
          a: 'We offer both flat-rate and hourly pricing depending on your move. After you request a quote, a specialist calls you to discuss the best option for your situation.',
        },
        {
          q: 'Are packing materials included?',
          a: 'Packing materials (boxes, tape, paper, plastic wrap) are billed separately based on what you actually use. Our team brings what is needed and you only pay for what is used.',
        },
        {
          q: 'What if I need to change the date?',
          a: 'You get 2 free date changes with at least 72 hours of notice.',
        },
        {
          q: 'Are you licensed and insured?',
          a: 'Yes. Move Fighters is fully licensed and insured in the State of Florida.',
        },
        {
          q: 'What areas do you cover?',
          a: 'All of Florida, from Pensacola to Key West. Coordinated dispatch for urban, suburban, and coastal areas.',
        },
        {
          q: 'Do you disassemble and reassemble furniture?',
          a: 'Yes. Beds, tables, shelves — our Fighters handle disassembly and reassembly at no extra cost on most packages.',
        },
      ],
    },
    finalCta: {
      title: 'READY FOR YOUR RESCUE?',
      sub: 'Join hundreds of Florida families who chose the Fighters. Request your quote in under 60 seconds.',
      primaryBtn: 'REQUEST MY QUOTE',
      secondaryBtn: 'CALL US',
    },
    footer: {
      helpBar: 'NEED IMMEDIATE HELP?',
      helpSub: 'Licensed & Insured — FL Mover Registration Active',
      tagline: "Florida's residential and commercial moving squad.",
      badges: [
        'Flexible Pricing',
        'No Surprise Fees',
        'Licensed & Insured',
        'Florida Local',
      ],
      newsletterTitle: 'GET MOVING TIPS & DEALS',
      emailPlaceholder: 'Enter your email',
      subscribe: 'SUBSCRIBE',
      noSpam: 'No spam. Unsubscribe anytime.',
      servicesTitle: 'OUR SERVICES',
      servicesLinks: [
        'Residential Moving',
        'Commercial Moving',
        'Furniture Assembly',
        'TV & Electronics Protection',
        'Packing & Unpacking',
        'Same-Week Scheduling',
      ],
      legalTitle: 'LEGAL',
      legalLinks: [
        'Terms of Service',
        'Privacy Policy',
        'Cancellation Policy',
        'Insurance & Liability',
      ],
      companyTitle: 'COMPANY',
      companyLinks: [
        'About Move Fighters',
        'Our Fleet',
        'Coverage Area',
        'Careers',
        'Contact Us',
      ],
      contactTitle: 'CONTACT',
      callNow: 'Call Now',
      hours: 'Mon–Sat: 7:00 AM – 8:00 PM',
      hoursSunday: 'Sunday: 8:00 AM – 5:00 PM',
      address: 'Florida — Statewide Service',
      paymentTitle: 'WE ACCEPT',
      rights: '© 2026 Move Fighters LLC. All rights reserved.',
      bottomLinks: [
        'Terms of Service',
        'Privacy Policy',
        'Cancellation Policy',
      ],
    },
    infoPages: {
      closeBtn: 'Close',
      lastUpdated: 'Last updated: May 2026',
      terms: {
        title: 'Terms of Service',
        sections: [
          {
            heading: 'Acceptance of Terms',
            body: 'By booking a move with Move Fighters LLC, you agree to these Terms of Service. If you do not agree, please do not use our services.',
          },
          {
            heading: 'Service Scope',
            body: 'Move Fighters provides residential and commercial moving, packing, furniture assembly, and related logistics within the State of Florida. A signed bill of lading is required at the start of every move.',
          },
          {
            heading: 'Pricing',
            body: 'We offer both flat-rate and hourly pricing. Final pricing is confirmed by phone after you submit your quote request. Quotes are valid for 14 days unless otherwise stated.',
          },
          {
            heading: 'Customer Responsibilities',
            body: 'You agree to provide accurate inventory and address details, ensure access to both locations, secure parking when required, and disclose any items requiring special handling.',
          },
          {
            heading: 'Limitation of Liability',
            body: 'Move Fighters carries Florida-required cargo and liability insurance. Maximum liability for loss or damage is limited to $0.60 per pound per item unless additional valuation coverage is purchased in writing prior to the move.',
          },
          {
            heading: 'Governing Law',
            body: 'These terms are governed by the laws of the State of Florida. Any disputes will be resolved in the courts of Hillsborough or Orange County, FL.',
          },
        ],
      },
      privacy: {
        title: 'Privacy Policy',
        sections: [
          {
            heading: 'What We Collect',
            body: 'We collect the information you provide when requesting a quote: name, phone, email, addresses, move date, inventory details, and any photos or videos you share with us.',
          },
          {
            heading: 'How We Use It',
            body: 'Your information is used solely to prepare your quote, schedule your move, communicate with you, and improve our service. We never sell your personal information.',
          },
          {
            heading: 'Sharing',
            body: 'We may share information with our crews and dispatch software to coordinate your move. We may share with law enforcement only when required by Florida or federal law.',
          },
          {
            heading: 'Data Retention',
            body: 'Customer records are retained for 7 years to comply with FL Department of Agriculture mover record requirements, then securely deleted.',
          },
          {
            heading: 'Your Rights',
            body: 'You may request access, correction, or deletion of your personal data at any time by emailing movefighters@gmail.com.',
          },
          {
            heading: 'Contact',
            body: 'Questions about privacy? Email us at movefighters@gmail.com or call (813) 476-8935.',
          },
        ],
      },
      cancellation: {
        title: 'Cancellation Policy',
        sections: [
          {
            heading: 'Free Cancellation',
            body: 'You may cancel your move at no charge with at least 72 hours of notice before the scheduled start time.',
          },
          {
            heading: 'Late Cancellation',
            body: 'Cancellations made within 72 hours of the scheduled move are subject to a $150 dispatch fee to cover crew scheduling.',
          },
          {
            heading: 'Same-Day / No-Show',
            body: 'Same-day cancellations or no-shows are billed a 2-hour minimum at the agreed rate.',
          },
          {
            heading: 'Date Changes',
            body: 'You receive 2 free date changes with at least 72 hours of notice. Additional changes may be subject to availability and a $50 rescheduling fee.',
          },
          {
            heading: 'Weather & Force Majeure',
            body: 'If we cancel due to severe weather, hurricanes, or other force majeure events, you receive a full refund or free reschedule with no penalty.',
          },
          {
            heading: 'How to Cancel',
            body: 'Call (813) 476-8935 or email movefighters@gmail.com. Cancellations are confirmed only after you receive written confirmation from our team.',
          },
        ],
      },
      insurance: {
        title: 'Insurance & Liability',
        sections: [
          {
            heading: 'Licensed & Insured',
            body: 'Move Fighters LLC is licensed by the Florida Department of Agriculture and Consumer Services as a registered intrastate mover, and carries general liability and cargo insurance as required by state law.',
          },
          {
            heading: 'Standard Coverage',
            body: 'All shipments include standard cargo coverage at $0.60 per pound per item — the Florida statutory minimum for intrastate moves.',
          },
          {
            heading: 'Full Value Protection',
            body: 'Optional Full Value Protection is available for an additional fee and covers the actual replacement value of damaged or lost items. Ask your specialist for pricing during your quote call.',
          },
          {
            heading: 'Items We Cannot Cover',
            body: 'Cash, jewelry, important documents, prescription medication, perishables, plants, hazardous materials, firearms, and items of extraordinary value (over $1,000 per item) require special arrangements or are excluded from standard coverage.',
          },
          {
            heading: 'Filing a Claim',
            body: 'If something is damaged, notify us within 7 days of delivery. Email photos and a description to movefighters@gmail.com. Most claims are resolved within 30 days.',
          },
        ],
      },
      about: {
        title: 'About Move Fighters',
        sections: [
          {
            heading: 'Who We Are',
            body: 'Move Fighters is a Florida-based moving company built around a simple promise: treat every move like a rescue mission. We are licensed, insured, uniformed, and trained to handle homes and businesses with the urgency and care of a first responder.',
          },
          {
            heading: 'Our Mission',
            body: 'Make moving in Florida fast, transparent, and stress-free. No surprise fees. No flaky crews. No damaged furniture. Just a squad of Fighters who show up on time and finish strong.',
          },
          {
            heading: 'Why "Fighters"',
            body: 'Florida moves are not easy — heat, stairs, narrow elevators, hurricane season, traffic. We named our crew the Fighters because that is what it takes to get your move done right.',
          },
          {
            heading: 'By the Numbers',
            body: '500+ moves completed across Florida. 4.9-star average rating. 95% of moves finished within the original time estimate. 0 hidden fees, ever.',
          },
        ],
      },
      fleet: {
        title: 'Our Fleet',
        sections: [
          {
            heading: 'Modern Trucks',
            body: 'Our fleet includes 16-ft, 20-ft, and 26-ft box trucks with lift gates, e-track tie-downs, and floor-to-ceiling padding — all GPS-tracked so dispatch always knows where your shipment is.',
          },
          {
            heading: 'Equipment on Every Job',
            body: 'Furniture dollies, appliance dollies, four-wheel platform carts, ratchet straps, plastic wrap, tools for disassembly/reassembly, door jamb protectors, and floor runners come standard.',
          },
          {
            heading: 'Specialty Equipment',
            body: 'For pianos, safes, pool tables, gym equipment, and oversized items we deploy specialty rigging, stair-climbing dollies, and additional crew at no surprise cost when disclosed during your quote.',
          },
          {
            heading: 'Maintenance & Safety',
            body: 'Every truck is inspected before each shift. Drivers carry valid CDL credentials where required and complete annual defensive driving certification.',
          },
        ],
      },
      coverage: {
        title: 'Coverage Area',
        sections: [
          {
            heading: 'Statewide Florida',
            body: 'We serve the entire state of Florida — from Pensacola in the Panhandle to Key West in the Keys, and everything in between.',
          },
          {
            heading: 'Major Metros',
            body: 'Tampa Bay, Orlando, Miami-Dade, Jacksonville, Fort Lauderdale, West Palm Beach, Naples / Fort Myers, Sarasota, Gainesville, Tallahassee, Pensacola, Daytona Beach.',
          },
          {
            heading: 'Local Coverage',
            body: 'Plus 60+ additional cities including Boca Raton, Delray Beach, Wellington, Doral, Kissimmee, Lakeland, Ocala, St. Augustine, Vero Beach, Cape Coral, and more.',
          },
          {
            heading: 'Long-Distance Within FL',
            body: 'Cross-state moves within Florida are dispatched as dedicated trucks — no shared loads, no transfer warehouses. Your stuff goes straight from origin to destination.',
          },
          {
            heading: 'Outside Florida?',
            body: 'For moves leaving Florida, contact us — we partner with vetted interstate carriers and can coordinate your relocation end to end.',
          },
        ],
      },
      careers: {
        title: 'Careers at Move Fighters',
        sections: [
          {
            heading: 'Join the Squad',
            body: 'We hire movers, drivers, dispatchers, and crew leads year-round. If you take pride in physical work, show up on time, and treat customer property like your own, we want to talk.',
          },
          {
            heading: 'What We Offer',
            body: 'Competitive hourly pay, paid training, tip-friendly culture, weekly pay, uniforms provided, and real career growth — most of our crew leads started as movers.',
          },
          {
            heading: 'Requirements',
            body: 'Must be 18+, eligible to work in the U.S., able to lift 75 lbs repeatedly, and pass a background check. CDL is a plus but not required for entry-level roles.',
          },
          {
            heading: 'How to Apply',
            body: 'Email your name, phone, location, and any moving experience to movefighters@gmail.com with the subject "Careers" — we reply within 48 hours.',
          },
        ],
      },
      contact: {
        title: 'Contact Us',
        sections: [
          {
            heading: 'Phone',
            body: '(813) 476-8935 — Monday to Saturday, 7:00 AM to 8:00 PM. Sunday 8:00 AM to 5:00 PM. We answer calls in English and Spanish.',
          },
          {
            heading: 'Email',
            body: 'movefighters@gmail.com — for quotes, claims, careers, or general questions. Replies within 24 hours.',
          },
          {
            heading: 'Quote Requests',
            body: 'For the fastest response, use the booking form or "Get a Quote" button on this site. Our specialist calls you back with the final price within minutes during business hours.',
          },
          {
            heading: 'Service Area',
            body: 'Florida — statewide. Headquartered in Tampa with crews dispatched from Tampa, Orlando, Miami, and Jacksonville.',
          },
          {
            heading: 'Press & Partnerships',
            body: 'For media, real estate partnerships, or referral programs, email movefighters@gmail.com with the subject "Partnership."',
          },
        ],
      },
      residential: {
        title: 'Residential Moving',
        sections: [
          {
            heading: 'Houses & Apartments',
            body: 'Studios to 5+ bedroom homes — we handle them all. Stairs, narrow halls, and elevators are included at no extra charge on every residential package.',
          },
          {
            heading: "What's Included",
            body: 'Uniformed Fighters, moving truck sized to your home, travel fee, disassembly and reassembly of furniture, padding and protection during transport, and residential cargo insurance.',
          },
          {
            heading: 'Typical Timeline',
            body: '1-bedroom: 3–5 hours. 2-bedroom: 4–7 hours. 3-bedroom: 6–9 hours. 4+ bedroom: 8+ hours, often split across two days for cross-state moves.',
          },
        ],
      },
      commercial: {
        title: 'Commercial Moving',
        sections: [
          {
            heading: 'Offices & Retail',
            body: 'We move offices, retail stores, restaurants, and small warehouses across Florida — usually after-hours or on weekends so your business never slows down.',
          },
          {
            heading: 'IT & Equipment',
            body: 'Computers, monitors, servers, printers, and POS systems are wrapped, padded, and labeled. We can coordinate with your IT team to disconnect and reconnect on the other side.',
          },
          {
            heading: 'Furniture & Fixtures',
            body: 'Cubicles, conference tables, filing cabinets, retail displays — disassembly, transport, and reassembly handled by experienced crews.',
          },
          {
            heading: 'Custom Quote',
            body: 'Every commercial move is unique. A specialist visits your site or reviews photos/floor plans to build a fixed quote with a clear timeline.',
          },
        ],
      },
      furnitureAssembly: {
        title: 'Furniture Assembly',
        sections: [
          {
            heading: 'Included on Most Moves',
            body: 'Beds, bed frames, dining tables, dressers, shelves, desks, and entertainment centers are disassembled at the origin and reassembled at the destination at no extra cost on most packages.',
          },
          {
            heading: 'Standalone Service',
            body: 'Need only assembly without a move? We assemble IKEA, Wayfair, Pottery Barn, and other flat-pack furniture by the hour. Call for a quick quote.',
          },
          {
            heading: 'What We Need from You',
            body: 'Original instructions if available, all hardware, and clear access to the room. We bring our own tools.',
          },
        ],
      },
      tvProtection: {
        title: 'TV & Electronics Protection',
        sections: [
          {
            heading: 'TV Wrapping',
            body: 'Every TV is wrapped in industrial blankets, protected with corner guards, and secured upright in the truck — never laid flat. We handle screens up to 85".',
          },
          {
            heading: 'Wall Mounts',
            body: 'We can dismount your TV from the wall at the origin and remount it at the destination for an additional fee. Mounts and hardware billed at cost if needed.',
          },
          {
            heading: 'Other Electronics',
            body: 'Computers, gaming consoles, sound systems, and home office equipment receive padded boxes and anti-static handling.',
          },
        ],
      },
      packing: {
        title: 'Packing & Unpacking',
        sections: [
          {
            heading: 'Full Packing',
            body: 'Our crew packs every room — kitchen, closets, garage, attic — using professional-grade boxes, packing paper, bubble wrap, and dish packs.',
          },
          {
            heading: 'Partial Packing',
            body: 'Just need help with the fragile stuff? We can pack only kitchens, art, electronics, or any specific rooms you choose.',
          },
          {
            heading: 'Materials',
            body: 'Boxes, tape, paper, and plastic wrap are billed separately based on actual usage. Our team brings what is needed and you only pay for what is used.',
          },
          {
            heading: 'Unpacking',
            body: 'After delivery, we can unpack and place items in cabinets, closets, and shelves — leaving your new home ready to live in.',
          },
        ],
      },
      sameWeek: {
        title: 'Same-Week Scheduling',
        sections: [
          {
            heading: 'Fast Dispatch',
            body: 'Most moves can be scheduled within 2–5 days of your quote, depending on crew availability and the size of your move.',
          },
          {
            heading: 'Last-Minute Moves',
            body: 'Need to move tomorrow? Call (813) 476-8935 — we keep emergency capacity for urgent dispatches across Tampa, Orlando, Miami, and Jacksonville.',
          },
          {
            heading: 'Date Flexibility',
            body: 'Flexible on date? Tell us during the quote call — flexible-date moves often unlock better pricing and earlier availability.',
          },
        ],
      },
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      pricing: 'Precios',
      gallery: 'Galería',
      faq: 'Preguntas',
      rescueMe: 'COTIZAR',
    },
    hero: {
      headline: '¿MUDANZA CRÍTICA? LLAMA A LOS FIGHTERS.',
      sub: 'No solo movemos cajas; ejecutamos rescates residenciales. Tarifa fija o por hora. El escuadrón de mudanzas más confiable de Florida.',
      cta: 'OBTENER COTIZACIÓN',
    },
    trustBar: {
      moves: 'Rescates Exitosos',
      rating: 'Calificación Google',
      pricing: 'Precios Flexibles',
      licensed: 'Licencia y Seguro',
    },
    howItWorks: {
      title: 'CÓMO FUNCIONA',
      step1: {
        title: 'Solicita Tu Rescate',
        desc: 'Llena el formulario. Un especialista te llama para discutir detalles y precios.',
      },
      step2: {
        title: 'Desplegamos',
        desc: 'Nuestro escuadrón uniformado llega a tiempo con todo el equipo listo.',
      },
      step3: {
        title: 'Misión Cumplida',
        desc: 'Todo en su lugar. Factura transparente. Trabajo terminado.',
      },
    },
    booking: {
      title: 'SOLICITAR UN RESCATE',
      subtitle:
        'Llena el formulario y un especialista de Move Fighters te llamará para discutir los detalles de tu mudanza y tu cotización personalizada.',
      sizeLabel: 'Tamaño de la Mudanza',
      sizeOptions: [
        { value: 'studio', label: 'Estudio / 1 Habitación' },
        { value: '2bedroom', label: '2 Habitaciones' },
        { value: '3bedroom', label: '3 Habitaciones' },
        { value: '4bedroom', label: '4+ Habitaciones / Casa Grande' },
        { value: 'office', label: 'Oficina / Comercial' },
      ],
      serviceTypeLabel: 'Preferencia de Precio',
      serviceTypeOptions: [
        { value: 'flat', label: 'Tarifa Fija' },
        { value: 'hourly', label: 'Por Hora' },
        { value: 'either', label: 'Muéstrenme Ambos' },
      ],
      originLabel: 'Dirección de Origen',
      destLabel: 'Dirección de Destino',
      dateLabel: 'Fecha Preferida de Mudanza',
      dateHint: 'Recomendamos avisar con 72h',
      nameLabel: 'Nombre Completo',
      emailLabel: 'Correo Electrónico',
      phoneLabel: 'Número de Teléfono',
      notesLabel: 'Notas Adicionales (opcional)',
      notesPlaceholder:
        'Escaleras, artículos grandes, restricciones de parking, etc.',
      submit: 'ENVIAR SOLICITUD',
      submitting: 'ENVIANDO...',
      footer: 'No se requiere pago. Un especialista te contactará en breve.',
      success: {
        title: 'SOLICITUD RECIBIDA',
        message:
          'Gracias por elegir Move Fighters. En breve recibirás una llamada desde el',
        phone: '(813) 476-8935',
        message2:
          'con tu cotización y el precio final de tu mudanza. Por favor contesta — la llamada vendrá desde este mismo número para no perder tu rescate.',
        cta: 'VOLVER AL INICIO',
      },
      error:
        'Algo salió mal. Por favor intenta de nuevo o llámanos al (813) 476-8935.',
    },
    pricing: {
      title: 'NUESTROS PAQUETES DE MUDANZA',
      subtitle:
        'Elige el paquete que se ajuste a tu mudanza. El precio final se entrega después de una breve llamada con nuestro especialista.',
      popular: 'MÁS POPULAR',
      cta: 'COTIZAR',
      cards: [
        {
          title: 'Estudio / 1 Habitación',
          features: [
            '2 Fighters',
            'Camión de Mudanza',
            'Tarifa de Viaje Incluida',
            'Desarmado y Rearmado Incluido',
            'Escaleras Sin Cargo Extra',
            'Seguro Residencial',
          ],
        },
        {
          title: 'Casa de 2 Habitaciones',
          features: [
            '3 Fighters',
            'Camión de Mudanza',
            'Tarifa de Viaje Incluida',
            'Desarmado y Rearmado Incluido',
            'Escaleras Sin Cargo Extra',
            'Seguro Residencial',
          ],
        },
        {
          title: 'Casa de 3 Habitaciones',
          features: [
            '3 Fighters',
            'Camión Más Grande',
            'Tarifa de Viaje Incluida',
            'Desarmado y Rearmado Incluido',
            'Programación Prioritaria',
            'Seguro Residencial',
          ],
        },
        {
          title: '4+ Habitaciones / Custom',
          features: [
            '4+ Fighters',
            'Múltiples Camiones',
            'Tarifa de Viaje Incluida',
            'Desarmado y Rearmado Incluido',
            'Coordinador Dedicado',
            'Servicio de Guante Blanco',
          ],
        },
      ],
      note: '* Materiales de embalaje (cajas, cinta, papel, plástico) se facturan por separado según su uso.',
    },
    quoteModal: {
      title: 'CUÉNTANOS SOBRE TU MUDANZA',
      subtitle:
        'Cuantos más detalles compartas, más precisa será tu cotización. Nuestro especialista te llamará con el precio final.',
      selectedPackage: 'Paquete seleccionado',
      sectionContact: 'Tus datos de contacto',
      sectionAddresses: 'Direcciones',
      sectionDate: '¿Cuándo te mudas?',
      sectionInventory: 'Inventario y detalles',
      sectionPhotos: 'Fotos (opcional pero recomendado)',
      nameLabel: 'Nombre Completo',
      phoneLabel: 'Teléfono',
      emailLabel: 'Correo Electrónico',
      originLabel: 'Dirección de Origen',
      originPlaceholder:
        '123 Calle Principal, Ciudad, FL — incluye piso / apto',
      destLabel: 'Dirección de Destino',
      destPlaceholder: '456 Calle Nueva, Ciudad, FL — incluye piso / apto',
      stairsLabel: 'Escaleras / Ascensor',
      stairsOptions: [
        { value: 'ground', label: 'Solo planta baja' },
        { value: 'stairs', label: 'Escaleras' },
        { value: 'elevator', label: 'Ascensor' },
        { value: 'both', label: 'Ambas ubicaciones tienen escaleras/ascensor' },
      ],
      dateLabel: 'Fecha Preferida',
      dateFlexLabel: 'Flexibilidad',
      dateFlexOptions: [
        { value: 'exact', label: 'Fecha exacta' },
        { value: 'flexible-3', label: 'Flexible (±3 días)' },
        { value: 'flexible-week', label: 'Flexible (dentro de una semana)' },
        { value: 'asap', label: 'Lo antes posible' },
      ],
      inventoryLabel: 'Describe tu inventario',
      inventoryPlaceholder:
        'Lista habitaciones y artículos principales (ej. cama king, sofá seccional, lavadora/secadora, TV 55", mesa para 6, espejos grandes, equipo de gimnasio...)',
      specialItemsLabel: 'Artículos especiales (marca todos los que apliquen)',
      specialItems: [
        'Piano',
        'Mesa de Billar',
        'Caja Fuerte',
        'Caja para Armas',
        'Arte / Antigüedades',
        'Acuario',
        'Caminadora / Gimnasio',
        'TV Grande (65"+)',
        'Jacuzzi',
        'Electrodomésticos',
      ],
      packingLabel: '¿Necesitas servicio de embalaje?',
      packingOptions: [
        { value: 'no', label: 'No, yo empaco todo' },
        { value: 'partial', label: 'Parcial — necesito ayuda con frágiles' },
        { value: 'full', label: 'Servicio completo de embalaje' },
      ],
      notesLabel: 'Necesidades especiales u otra cosa que debamos saber',
      notesPlaceholder:
        'Distancia larga de carga, puertas estrechas, restricciones de parking, ventanas de tiempo, mascotas, etc.',
      photosLabel: 'Sube fotos y videos de tus artículos / habitaciones',
      photosHint:
        'Imágenes y videos bienvenidos. Hasta 15 archivos, 50 MB en total. Nos ayuda a cotizar con precisión.',
      photosButton: 'Elegir archivos',
      photosSelected: 'archivo(s) seleccionado(s)',
      maxFilesNote: 'archivos máx',
      maxTotalNote: '50 MB total',
      largeFilesNote:
        'Tus archivos son grandes. Enviaremos tus datos a nuestro equipo y te pediremos que también compartas las fotos/videos por WhatsApp o mensaje al (813) 476-8935 — así nada se pierde.',
      submit: 'ENVIAR MIS DATOS',
      submitting: 'ENVIANDO...',
      cancel: 'Cancelar',
      success: {
        title: 'RECIBIDO — DATOS REGISTRADOS',
        message: 'Gracias. Nuestro especialista te llamará en breve desde el',
        phone: '(813) 476-8935',
        message2:
          'con tu cotización y el precio final. Por favor contesta — la llamada vendrá desde este mismo número.',
        nextStepsTitle: 'Qué sigue ahora',
        nextSteps: [
          'Nuestro especialista revisa tu inventario y direcciones (en minutos durante horario laboral).',
          'Recibes una llamada desde el (813) 476-8935 con tu cotización personalizada y el precio final.',
          'Una vez confirmes, aseguramos tu fecha y tu escuadrón de Fighters.',
        ],
        largeFilesTitle: 'Un pequeño favor',
        largeFilesMessage:
          'Tus fotos/videos eran demasiado grandes para adjuntar. Envíalas por WhatsApp o mensaje al (813) 476-8935 para finalizar tu cotización más rápido.',
        cta: 'CERRAR',
      },
      error:
        'Algo salió mal. Por favor intenta de nuevo o llámanos al (813) 476-8935.',
      photosTooLarge:
        'El tamaño total de los archivos supera los 50 MB. Elimina algunos o usa archivos más pequeños.',
    },
    services: {
      title: 'NUESTROS PROTOCOLOS DE RESCATE',
      items: [
        {
          title: 'Rescate Residencial',
          desc: 'Casas y apartamentos manejados por Fighters uniformados. Escaleras, pasillos estrechos y elevadores incluidos sin cargo extra.',
        },
        {
          title: 'Mudanzas Comerciales',
          desc: 'Mudanzas de oficinas y locales ejecutadas rápido para que tu negocio nunca se detenga.',
        },
        {
          title: 'Embalaje y Protección',
          desc: 'Servicio de embalaje opcional disponible. Mantas industriales, plástico protector y cajas profesionales disponibles bajo solicitud, facturados por separado.',
        },
        {
          title: 'Despacho de Prioridad',
          desc: 'Logística coordinada en tiempo récord para mudanzas urgentes o con fecha fija en toda Florida.',
        },
      ],
    },
    guarantee: {
      title: 'LA GARANTÍA MOVE FIGHTERS',
      sub: 'Precios transparentes. Servicio honesto. Siempre puntuales.',
      items: [
        'Sin Cargos Sorpresa',
        'Llegada Puntual',
        'Protección contra Daños',
      ],
    },
    gallery: {
      title: 'FIGHTERS EN ACCIÓN',
    },
    testimonials: {
      title: 'LO QUE DICEN NUESTRAS FAMILIAS RESCATADAS',
      reviews: [
        {
          quote:
            'Estos chicos son de verdad. Precios claros, sin sorpresas, y trataron mis muebles como si fueran suyos. ¡Los mejores de Tampa!',
          name: 'Maria G.',
          location: 'Tampa, FL',
          timeAgo: 'hace 2 meses',
          color: 'bg-blue-500',
        },
        {
          quote:
            'Estaba estresado por mi mudanza de último minuto, pero Move Fighters llegó a tiempo y terminó todo en 3 horas. Increíble.',
          name: 'James R.',
          location: 'Orlando, FL',
          timeAgo: 'hace 3 semanas',
          color: 'bg-red-500',
        },
        {
          quote:
            'Profesionales de verdad. El especialista me llamó en minutos después de pedir cotización. Mi mudanza de 3 habitaciones fue perfecta.',
          name: 'Carlos M.',
          location: 'Miami, FL',
          timeAgo: 'hace 1 mes',
          color: 'bg-green-500',
        },
      ],
    },
    coverage: {
      title: 'LA RED DE RESCATE MÁS GRANDE DE FLORIDA',
      subtitle: 'Cubrimos todo el estado, desde el Panhandle hasta los Keys.',
      mapHint: 'Toca un pin para ver detalles de cobertura',
    },
    faq: {
      title: 'PREGUNTAS FRECUENTES',
      items: [
        {
          q: '¿Cómo funcionan los precios?',
          a: 'Ofrecemos tarifa fija y por hora dependiendo de tu mudanza. Después de solicitar cotización, un especialista te llama para discutir la mejor opción para tu situación.',
        },
        {
          q: '¿Los materiales de embalaje están incluidos?',
          a: 'Los materiales (cajas, cinta, papel, plástico) se facturan por separado según lo que realmente uses. Nuestro equipo trae lo necesario y solo pagas lo que se utiliza.',
        },
        {
          q: '¿Qué pasa si necesito cambiar la fecha?',
          a: 'Tienes 2 cambios de fecha gratis con al menos 72 horas de aviso.',
        },
        {
          q: '¿Tienen licencia y seguro?',
          a: 'Sí. Move Fighters cuenta con licencia completa y seguro en el Estado de Florida.',
        },
        {
          q: '¿Qué áreas cubren?',
          a: 'Toda Florida, desde Pensacola hasta Key West. Despacho coordinado para áreas urbanas, suburbanas y costeras.',
        },
        {
          q: '¿Desarman y rearman muebles?',
          a: 'Sí. Camas, mesas, estantes — nuestros Fighters se encargan del desarmado y rearmado sin costo extra en la mayoría de los paquetes.',
        },
      ],
    },
    finalCta: {
      title: '¿LISTO PARA TU RESCATE?',
      sub: 'Únete a cientos de familias de Florida que eligieron a los Fighters. Solicita tu cotización en menos de 60 segundos.',
      primaryBtn: 'COTIZAR AHORA',
      secondaryBtn: 'LLÁMANOS',
    },
    footer: {
      helpBar: '¿NECESITAS AYUDA INMEDIATA?',
      helpSub: 'Con Licencia y Seguro — Registro de Mudanzas FL Activo',
      tagline: 'El escuadrón residencial y comercial de mudanzas de Florida.',
      badges: [
        'Precios Flexibles',
        'Sin Cargos Sorpresa',
        'Licencia y Seguro',
        'Local de Florida',
      ],
      newsletterTitle: 'CONSEJOS Y OFERTAS',
      emailPlaceholder: 'Tu correo electrónico',
      subscribe: 'SUSCRIBIRSE',
      noSpam: 'Sin spam. Cancela cuando quieras.',
      servicesTitle: 'NUESTROS SERVICIOS',
      servicesLinks: [
        'Mudanza Residencial',
        'Mudanza Comercial',
        'Armado de Muebles',
        'Protección de TV y Electrónicos',
        'Embalaje y Desembalaje',
        'Programación Misma Semana',
      ],
      legalTitle: 'LEGAL',
      legalLinks: [
        'Términos de Servicio',
        'Política de Privacidad',
        'Política de Cancelación',
        'Seguro y Responsabilidad',
      ],
      companyTitle: 'EMPRESA',
      companyLinks: [
        'Sobre Move Fighters',
        'Nuestra Flota',
        'Área de Cobertura',
        'Carreras',
        'Contáctanos',
      ],
      contactTitle: 'CONTACTO',
      callNow: 'Llamar Ahora',
      hours: 'Lun–Sáb: 7:00 AM – 8:00 PM',
      hoursSunday: 'Domingo: 8:00 AM – 5:00 PM',
      address: 'Florida — Servicio Estatal',
      paymentTitle: 'ACEPTAMOS',
      rights: '© 2026 Move Fighters LLC. Todos los derechos reservados.',
      bottomLinks: [
        'Términos de Servicio',
        'Política de Privacidad',
        'Política de Cancelación',
      ],
    },
    infoPages: {
      closeLabel: 'Cerrar',
      lastUpdated: 'Última actualización: enero 2026',
      pages: {
        terms: {
          title: 'Términos de Servicio',
          intro:
            'Al reservar una mudanza con Move Fighters LLC, aceptas los siguientes términos. Estos términos protegen tanto a ti como a nuestro equipo y garantizan que cada rescate sea transparente y justo.',
          sections: [
            {
              h: '1. Acuerdo de Servicio',
              p: 'Move Fighters LLC presta servicios de mudanza residencial y comercial en todo el Estado de Florida. Todos los servicios se prestan por Fighters uniformados y capacitados bajo nuestro Registro de Mudanzas de Florida y autoridades USDOT.',
            },
            {
              h: '2. Cotizaciones y Precios',
              p: 'Las cotizaciones se ofrecen como tarifa fija o por hora. El precio final se confirma en la llamada de agenda antes de reservar la mudanza. Los materiales de embalaje se facturan por separado según el uso real.',
            },
            {
              h: '3. Responsabilidades del Cliente',
              p: 'El cliente es responsable de informar sobre artículos grandes, frágiles o especiales, proporcionar direcciones exactas y garantizar acceso seguro a origen y destino (parking, ascensores, llaves, permisos cuando apliquen).',
            },
            {
              h: '4. Artículos no Permitidos',
              p: 'No transportamos materiales peligrosos, armas de fuego, plantas o animales vivos, alimentos perecederos, efectivo, ni documentos personales irremplazables. Move Fighters se reserva el derecho de rechazar cualquier artículo que considere inseguro.',
            },
            {
              h: '5. Responsabilidad',
              p: 'Incluimos la cobertura básica de valor según lo requerido por la ley de Florida. Protección de valor completo disponible bajo solicitud. Las reclamaciones deben presentarse dentro de los 9 meses posteriores a la entrega.',
            },
            {
              h: '6. Ley Aplicable',
              p: 'Estos términos se rigen por las leyes del Estado de Florida. Cualquier disputa se resolverá en los tribunales del condado donde Move Fighters LLC está registrada.',
            },
          ],
        },
        privacy: {
          title: 'Política de Privacidad',
          intro:
            'Tu privacidad importa. Esta política explica qué información recopilamos, cómo la usamos y las opciones que tienes.',
          sections: [
            {
              h: 'Información que recopilamos',
              p: 'Nombre, teléfono, correo, direcciones de origen y destino, fecha de mudanza, detalles de inventario y cualquier foto o video que compartas para preparar tu cotización.',
            },
            {
              h: 'Cómo la usamos',
              p: 'Usamos tu información estrictamente para preparar tu cotización, agendar tu mudanza, contactarte sobre actualizaciones del servicio y mejorar nuestras operaciones. Nunca vendemos ni alquilamos tus datos a terceros.',
            },
            {
              h: 'Quién tiene acceso',
              p: 'Solo el personal autorizado de Move Fighters y el equipo específico asignado a tu mudanza acceden a los detalles. Nuestro proveedor de email (EmailJS) procesa los envíos bajo un acuerdo estándar de procesamiento de datos.',
            },
            {
              h: 'Tus derechos',
              p: 'Puedes solicitar una copia, corrección o eliminación de tus datos personales en cualquier momento escribiendo a movefighters@gmail.com. Respondemos en un plazo de 30 días.',
            },
            {
              h: 'Cookies y analítica',
              p: 'Nuestro sitio usa cookies mínimas y esenciales. No usamos rastreo invasivo ni píxeles de publicidad.',
            },
          ],
        },
        cancellation: {
          title: 'Política de Cancelación',
          intro:
            'Sabemos que los planes cambian. Nuestra política es simple y justa para ambas partes.',
          sections: [
            {
              h: 'Reprogramación gratuita',
              p: 'Puedes reprogramar tu mudanza hasta 2 veces sin cargo, siempre que nos avises con al menos 72 horas de anticipación.',
            },
            {
              h: 'Cancelación con menos de 72 horas',
              p: 'Las cancelaciones con menos de 72 horas antes de la mudanza tienen un cargo fijo de $75 para cubrir la logística ya comprometida.',
            },
            {
              h: 'Cancelación el mismo día o no-show',
              p: 'Las cancelaciones el mismo día y los no-shows se cobran al 50% de la tarifa fija cotizada, o el mínimo de 2 horas en mudanzas por hora.',
            },
            {
              h: 'Clima y emergencias',
              p: 'Si el clima severo o una emergencia obligan a reprogramar, no hay cargo. Trabajaremos contigo para encontrar la siguiente fecha disponible.',
            },
          ],
        },
        insurance: {
          title: 'Seguro y Responsabilidad',
          intro:
            'Move Fighters LLC cuenta con licencia completa y seguro en el Estado de Florida. Esto es lo que significa para ti.',
          sections: [
            {
              h: 'Registro de Mudanzas de Florida',
              p: 'Mantenemos un Registro de Mudanzas de Florida activo y toda la cobertura de seguro requerida por el Departamento de Agricultura y Servicios al Consumidor de Florida.',
            },
            {
              h: 'Cobertura de carga',
              p: 'Todas las mudanzas incluyen la protección básica de valor a la tarifa estándar de Florida. Cubre tus artículos mientras están bajo nuestro cuidado y custodia.',
            },
            {
              h: 'Protección de valor completo',
              p: 'Disponible bajo solicitud por un cargo adicional. Esta opción cubre el valor de reemplazo total de tus artículos en el raro caso de daño o pérdida.',
            },
            {
              h: 'Compensación laboral',
              p: 'Cada Fighter de nuestro equipo está cubierto por compensación laboral, así que nunca quedas expuesto a responsabilidad si ocurre una lesión en sitio.',
            },
            {
              h: 'Cómo presentar un reclamo',
              p: 'Envía un correo a movefighters@gmail.com dentro de los 9 meses posteriores a la entrega, con fotos del artículo dañado y la fecha de tu mudanza. Un especialista responde en 3 días hábiles.',
            },
          ],
        },
        about: {
          title: 'Sobre Move Fighters',
          intro:
            'Move Fighters nació para elevar el estándar de las mudanzas en Florida. No solo movemos cajas — ejecutamos rescates residenciales.',
          sections: [
            {
              h: 'Nuestra misión',
              p: 'Ofrecer un servicio de mudanza honesto, transparente y respetuoso a toda familia y negocio de Florida. Sin cargos sorpresa. Sin recuerdos dañados. Sin citas perdidas.',
            },
            {
              h: 'Nuestro equipo',
              p: 'Cada Fighter del equipo tiene verificación de antecedentes, capacitación en levantamiento seguro y manejo de muebles, y se presenta uniformado. Contratamos primero por actitud y formamos las habilidades.',
            },
            {
              h: 'Nuestros valores',
              p: 'Puntualidad. Transparencia. Respeto por tu hogar. Respeto por nuestro equipo. Estos cuatro valores guían cada decisión, desde la cotización hasta la entrega.',
            },
          ],
        },
        fleet: {
          title: 'Nuestra Flota',
          intro:
            'Nuestros camiones se mantienen con estándares comerciales para que tu mudanza ocurra a tiempo, siempre.',
          sections: [
            {
              h: 'Tamaños de camión',
              p: 'Camiones de 16 pies para estudios y 1 habitación. Camiones de 20 pies para 2–3 habitaciones. Camiones de 26 pies para casas grandes, trabajos comerciales y mudanzas de larga distancia en Florida.',
            },
            {
              h: 'Equipo en cada camión',
              p: 'Carretillas, sliders, correas, mantas industriales, plástico protector, herramientas para desarmado y rearmado, y protección de pisos. Los materiales se facturan por separado según uso.',
            },
            {
              h: 'Mantenimiento',
              p: 'Cada camión recibe mantenimiento e inspecciones de seguridad programadas. Tenemos camiones y herramientas de respaldo para que una falla nunca se traduzca en una mudanza perdida.',
            },
          ],
        },
        coverageArea: {
          title: 'Área de Cobertura',
          intro:
            'Cubrimos todo el Estado de Florida, desde el Panhandle hasta los Keys.',
          sections: [
            {
              h: 'Regiones principales',
              p: 'Tampa Bay, Orlando, Miami-Dade, Broward, Palm Beach, Jacksonville, Fort Myers, Naples, Sarasota, Pensacola, Tallahassee, y cada ciudad y pueblo intermedio.',
            },
            {
              h: 'Mudanzas locales',
              p: 'Las mudanzas dentro de un área metropolitana o condado son nuestro trabajo diario. Programación en la misma semana disponible para la mayoría de rutas locales.',
            },
            {
              h: 'Larga distancia dentro de Florida',
              p: 'Las mudanzas entre ciudades (por ejemplo Tampa → Miami, Orlando → Key West, Pensacola → Jacksonville) las coordina un especialista dedicado para garantizar entrega en un solo día cuando es posible.',
            },
          ],
        },
        careers: {
          title: 'Carreras',
          intro:
            'Siempre buscamos Fighters confiables, respetuosos y orgullosos de su trabajo.',
          sections: [
            {
              h: 'Quién contratamos',
              p: 'Conductores con historial limpio, ayudantes con ética de trabajo, despachadores que rinden bajo presión. No se requiere experiencia previa en mudanzas — capacitamos a la gente adecuada.',
            },
            {
              h: 'Lo que ofrecemos',
              p: 'Pago competitivo, horario semanal, las propinas van 100% al equipo, entrenamiento pagado y cultura que respeta a cada Fighter.',
            },
            {
              h: 'Cómo aplicar',
              p: 'Envía tu nombre, teléfono, ciudad y una breve nota sobre tu experiencia a movefighters@gmail.com con el asunto "Careers". Respondemos en 3 días hábiles.',
            },
          ],
        },
        contact: {
          title: 'Contáctanos',
          intro:
            'Contáctanos como mejor te convenga. Un especialista responde en horario laboral y en el siguiente día hábil el resto del tiempo.',
          sections: [
            {
              h: 'Teléfono',
              p: '(813) 476-8935 — Lun–Sáb 7:00 AM – 8:00 PM, Domingo 8:00 AM – 5:00 PM.',
            },
            {
              h: 'Correo',
              p: 'movefighters@gmail.com — para cotizaciones, reclamos y consultas generales.',
            },
            {
              h: 'Área de servicio',
              p: 'Todo el Estado de Florida. Reserva con el formulario en la página principal o llámanos directamente.',
            },
            {
              h: 'Credenciales',
              p: 'Move Fighters LLC — Registro de Mudanzas FL Activo — Autoridades USDOT y MC archivadas. Con licencia completa y seguro.',
            },
          ],
        },
        residentialMoving: {
          title: 'Mudanza Residencial',
          intro:
            'Casas, apartamentos, condos y townhomes — nuestro servicio más solicitado. Ejecutado por Fighters uniformados que tratan tu hogar como el suyo.',
          sections: [
            {
              h: 'Qué incluye',
              p: 'Equipos uniformados de 2 a 4+ personas, camiones totalmente equipados, desarmado y rearmado de muebles estándar, escaleras y ascensores sin cargo extra, mantas industriales y protección de pisos en cada trabajo.',
            },
            {
              h: 'Cómo protegemos tu hogar',
              p: 'Protectores de marcos, alfombras de paso, barandas envueltas y walkthrough en origen y destino para documentar la condición antes y después.',
            },
            {
              h: 'Tiempos típicos',
              p: 'Estudio / 1 Hab: 2–4 horas. 2 Hab: 4–6 horas. 3 Hab: 6–8 horas. 4+ Hab / custom: día completo o despacho de múltiples camiones.',
            },
          ],
        },
        commercialMoving: {
          title: 'Mudanza Comercial',
          intro:
            'Mudanzas de oficinas y locales ejecutadas rápido para que tu negocio nunca se detenga. Agenda nocturna y de fin de semana disponible.',
          sections: [
            {
              h: 'Qué movemos',
              p: 'Escritorios, sillas, cubículos, archivadores, mesas de juntas, servidores y equipos IT, mobiliario retail, inventario y artículos comerciales especiales.',
            },
            {
              h: 'Mínimo tiempo de inactividad',
              p: 'Walkthrough previo, inventario detallado, plan de embalaje etiquetado y un coordinador dedicado para que las operaciones reanuden el mismo o siguiente día hábil.',
            },
            {
              h: 'Mudanzas fuera de horario',
              p: 'Equipos nocturnos y de fin de semana disponibles para que tu equipo entre a trabajar el lunes en la mañana.',
            },
          ],
        },
        furnitureAssembly: {
          title: 'Armado de Muebles',
          intro:
            'Camas, mesas, repisas, escritorios, cunas, gabinetes — el desarmado y rearmado están incluidos en la mayoría de los paquetes.',
          sections: [
            {
              h: 'Lo que manejamos',
              p: 'Muebles estándar pre-armados y flat-pack: IKEA, Ashley, Wayfair, Crate & Barrel, West Elm y marcas comparables. Las piezas especiales (pianos, mesas de billar, cajas fuertes) se cotizan por separado.',
            },
            {
              h: 'Lo que traemos',
              p: 'Taladros, brocas, trinquetes, llaves allen, mazos de goma, paños de microfibra limpios y herramientas sanitizadas. No dejamos hardware ni empaques.',
            },
            {
              h: 'Servicio independiente',
              p: '¿Necesitas armado sin una mudanza completa? Ofrecemos visitas de armado independientes. Llámanos para una cotización fija.',
            },
          ],
        },
        tvProtection: {
          title: 'Protección de TV y Electrónicos',
          intro:
            'Televisores, equipos de sonido y electrónicos necesitan manejo cuidadoso. Tenemos protocolos dedicados para que lleguen listos para conectar.',
          sections: [
            {
              h: 'Protección de TV',
              p: 'Las pantallas planas se envuelven en acolchado antiestático, se aseguran en cartones tipo picture-grade y van de pie en el camión — nunca acostadas ni apiladas.',
            },
            {
              h: 'Manejo de cables',
              p: 'Los cables se fotografían en origen, se embolsan y etiquetan, y se reconectan en destino a pedido.',
            },
            {
              h: 'Equipos sensibles',
              p: 'Computadoras, consolas de videojuegos, equipos de audio y componentes de home theater se asignan a un Fighter específico del equipo y se transportan en zonas climatizadas del camión.',
            },
          ],
        },
        packing: {
          title: 'Embalaje y Desembalaje',
          intro:
            'Servicio completo de embalaje opcional para quienes quieren un verdadero rescate puerta a puerta.',
          sections: [
            {
              h: 'Embalaje completo',
              p: 'Nuestro equipo empaca cada habitación, etiqueta cada caja por habitación de destino y genera un inventario. Servicio de desembalaje disponible en destino.',
            },
            {
              h: 'Embalaje parcial',
              p: 'Empaque solo de frágiles: cocina, cristalería, arte, electrónicos y cualquier cosa que prefieras dejar a profesionales.',
            },
            {
              h: 'Materiales',
              p: 'Cajas profesionales, cinta, papel de empaque, burbuja y plástico disponibles bajo pedido y facturados por separado según el uso real.',
            },
          ],
        },
        sameWeek: {
          title: 'Programación Misma Semana',
          intro:
            '¿Necesitas mudarte rápido? Reservamos capacidad diaria para rescates urgentes.',
          sections: [
            {
              h: 'Cómo funciona',
              p: 'Llámanos. Si tenemos un equipo disponible en tu área dentro de 72 horas, lo aseguramos y despachamos. Rescates el mismo día posibles sujeto a disponibilidad.',
            },
            {
              h: 'Por qué podemos hacerlo',
              p: 'Operamos múltiples equipos y camiones cada día en Florida, lo que nos permite absorber pedidos de último momento sin comprometer la calidad.',
            },
            {
              h: 'Precios',
              p: 'Los rescates de misma semana se cotizan igual que las mudanzas programadas. Sin recargos de emergencia. Lo cotizado es lo que pagas.',
            },
          ],
        },
      },
    },
  },
}
